<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Add New Node Configuration</h4>
  <i class="bi bi-x-lg text-danger" style="font-size:larger" (click)="onClose()"></i>
</div>

<div class="modal-body text-grey" style="overflow: auto;">
  <mat-stepper orientation="vertical" [linear]="isLinear" #stepper>
    <mat-step [stepControl]="cpuDetails">
      <form [formGroup]="cpuDetails">
        <ng-template matStepLabel >Config Details</ng-template>
        <mat-form-field style="width: 90%; margin:1%">
          <mat-label style="font-size:small">Config Code</mat-label>
          <input matInput
                 title="Config Code"
                 formControlName="instanceCode"
                 placeholder="Enter a codename for configuration" />
          <mat-error *ngIf="
              (cpuDetails.get('instanceCode').touched &&
              cpuDetails.get('instanceCode').errors?.required)
              ">
            Config code is required
          </mat-error>
        </mat-form-field>
        <mat-form-field style="width: 90%; margin:1%">
          <mat-label>CPU Cores per Node</mat-label>
          <input matInput
                 title="Total CPU Cores per Node"
                 formControlName="cpuCores"
                 placeholder="Number of CPU Cores per Node" />
          <mat-error *ngIf="
              (cpuDetails.get('cpuCores').touched &&
              cpuDetails.get('cpuCores').errors?.required) || cpuDetails.get('cpuCores').errors?.pattern
              ">
            Enter CPU Cores as integer
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 90%; margin: 1%">
          <mat-label>Select CPU Type</mat-label>
          <mat-select formControlName="cpuType">
            <mat-option value="Intel">Intel</mat-option>
            <mat-option value="AMD">AMD</mat-option>
          </mat-select>
          <mat-error *ngIf="
cpuDetails.get('cpuType').touched &&
cpuDetails.get('cpuType').errors?.required
">
            Select CPU Type
          </mat-error>
        </mat-form-field>
        <mat-form-field style="width: 90%; margin:1%">
          <mat-label>HPC Units Per Hour</mat-label>
          <input matInput
                 title="HPC Unit cost per hour"
                 formControlName="hpcUnits"
                 placeholder="Number of HPC Unit cost per hour" />
            <mat-error *ngIf="
              (cpuDetails.get('hpcUnits').touched &&
              cpuDetails.get('hpcUnits').errors?.required) || cpuDetails.get('hpcUnits').errors?.pattern
              ">
            Enter HPC Units as integer
          </mat-error>
        </mat-form-field>
        <mat-form-field style="width: 90%; margin:1%">
          <mat-label>Number of Sockets</mat-label>
          <input matInput
                 title="Number of Sockets"
                 formControlName="numofSockets"
                 placeholder="Enter Number of Sockets" />
          <mat-error *ngIf="
(cpuDetails.get('numofSockets').touched &&
cpuDetails.get('numofSockets').errors?.required) || cpuDetails.get('cpuCores').errors?.pattern
">
            Enter Number of Sockets as integer
          </mat-error>
        </mat-form-field>
        <mat-form-field style="width: 90%; margin:1%">
          <mat-label>Cores Per Sockets</mat-label>
          <input matInput
                 title="Cores Per Sockets"
                 formControlName="coresPerSocket"
                 placeholder="Enter Cores Per Sockets" />
          <mat-error *ngIf="
(cpuDetails.get('coresPerSocket').touched &&
cpuDetails.get('coresPerSocket').errors?.required) || cpuDetails.get('cpuCores').errors?.pattern
">
            Enter Cores Per Sockets as integer
          </mat-error>
        </mat-form-field>
        <mat-form-field style="width: 90%; margin:1%">
          <mat-label>Threads Per Core</mat-label>
          <input matInput
                 title="Threads Per Core"
                 formControlName="threadsPerCore"
                 placeholder="Enter Threads Per Core" />
          <mat-error *ngIf="
(cpuDetails.get('threadsPerCore').touched &&
cpuDetails.get('threadsPerCore').errors?.required) || cpuDetails.get('cpuCores').errors?.pattern
">
            Enter Threads Per Core as integer
          </mat-error>
        </mat-form-field>
        <div>
          <button class="btn btn-primary" matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="diskDetails">
      <form [formGroup]="diskDetails">
        <ng-template matStepLabel>Memory and Storage</ng-template>
        <mat-form-field style="width: 90%; margin:1%">
          <mat-label>RAM Size (GB)</mat-label>
          <input matInput
                 title="RAM Size"
                 formControlName="RAMSize"
                 placeholder="Enter RAM Size in GB" />
          <mat-error *ngIf="
(diskDetails.get('RAMSize').touched &&
diskDetails.get('RAMSize').errors?.required) || cpuDetails.get('cpuCores').errors?.pattern
">
            Enter RAM Size
          </mat-error>
        </mat-form-field>
        <mat-form-field style="width: 90%; margin:1%">
          <mat-label>Storage Size (GB)</mat-label>
          <input matInput
                 title="Storage Size"
                 formControlName="storageSize"
                 placeholder="Enter Storage Size in GB" />
          <mat-error *ngIf="
(diskDetails.get('storageSize').touched &&
diskDetails.get('storageSize').errors?.required) || cpuDetails.get('cpuCores').errors?.pattern
">
            Enter Storage Size in GB
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 90%; margin:1%">
          <mat-label>Select Storage Type</mat-label>
          <mat-select formControlName="storageType">
            <mat-option value="HDD">HDD</mat-option>
            <mat-option value="SSD">SSD</mat-option>
          </mat-select>
          <mat-error *ngIf="
diskDetails.get('storageType').touched &&
diskDetails.get('storageType').errors?.required
">
            Select Storage Type
          </mat-error>
        </mat-form-field>
        <div>
          <button class="btn btn-primary" matStepperPrevious>Back</button>
          <button class="btn btn-primary" matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="cloudInfraDetails">
      <form [formGroup]="cloudInfraDetails">
        <ng-template matStepLabel>Infrastructure Provider</ng-template>
        <mat-form-field appearance="fill" style="width: 90%; margin:1%">
          <mat-label>Select Cloud Infra</mat-label>
          <mat-select formControlName="cloudType">
            <mat-option *ngFor="let cloud of cloudProviders" value="{{cloud?.value}}">{{cloud?.name}}</mat-option>
            <!--<mat-option value="GCP">Google Cloud</mat-option>
            <mat-option value="AWS">AWS</mat-option>
            <mat-option value="OCI">Oracle Cloud</mat-option>
            <mat-option value="Azure">Azure</mat-option>
            <mat-option value="On-Premise">On-Premise</mat-option>-->
          </mat-select>
          <mat-error *ngIf="
cloudInfraDetails.get('cloudType').touched &&
cloudInfraDetails.get('cloudType').errors?.required
">
            Select Cloud Type
          </mat-error>
        </mat-form-field>
        <div>
          <button class="btn btn-primary" matStepperPrevious>Back</button>
          <button class="btn btn-primary" matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>


    <mat-step [stepControl]="gpuDetails">
      <form [formGroup]="gpuDetails">
        <ng-template matStepLabel>GPU Details</ng-template>
        <mat-form-field style="width: 90%; margin:1%">
          <mat-label>Number Of GPU</mat-label>
          <input matInput
                 title="Number Of GPU"
                 formControlName="noOfGpu"
                 placeholder="Enter Number Of GPU" />
          <mat-error *ngIf="
(gpuDetails.get('noOfGpu').touched &&
gpuDetails.get('noOfGpu').errors?.required) || cpuDetails.get('cpuCores').errors?.pattern
">
            Enter Number Of GPU as integer
          </mat-error>
        </mat-form-field>
        <mat-form-field style="width: 90%; margin:1%">
          <mat-label>GPU Memory Size</mat-label>
          <input matInput
                 title="GPU Memory Size"
                 formControlName="gpuMemorySize"
                 placeholder="Enter GPU Memory Size" />
          <mat-error *ngIf="
(gpuDetails.get('gpuMemorySize').touched &&
gpuDetails.get('gpuMemorySize').errors?.required) || cpuDetails.get('cpuCores').errors?.pattern
">
            Enter GPU Memory Size
          </mat-error>
        </mat-form-field>
        <mat-form-field style="width: 90%; margin:1%">
          <mat-label>GPU Model</mat-label>
          <input matInput
                 title="GPU Model"
                 formControlName="gpuModel"
                 placeholder="Enter GPU Model" />
          <mat-error *ngIf="
gpuDetails.get('gpuModel').touched &&
gpuDetails.get('gpuModel').errors?.required
">
            Enter GPU Model
          </mat-error>
        </mat-form-field>
        <div>
          <button class="btn btn-primary" matStepperPrevious>Back</button>
          <button class="btn btn-primary" matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="rdmaDetails">
      <form [formGroup]="rdmaDetails">
        <ng-template matStepLabel>RDMA Details</ng-template>
        <mat-form-field appearance="fill" style="width: 90%; margin:1%">
          <mat-label>Select RDMA Support</mat-label>
          <mat-select formControlName="isRDMAsupport">
            <mat-option value="true">Enabled</mat-option>
            <mat-option value="false">Disabled</mat-option>
          </mat-select>
          <mat-error *ngIf="
rdmaDetails.get('isRDMAsupport').touched &&
rdmaDetails.get('isRDMAsupport').errors?.required
">
            Select RDMA Support
          </mat-error>
        </mat-form-field>
        <div>
          <button class="btn btn-primary" matStepperPrevious>Back</button>
        </div>
      </form>
    </mat-step>

    <!--<mat-step>
      <ng-template matStepLabel>Done</ng-template>
      <p>You are now done.</p>
      <div>
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button (click)="stepper.reset()">Reset</button>
      </div>
    </mat-step>-->
  </mat-stepper>
</div>


<div class="modal-footer">
  <button type="button" class="btn btn-danger"
          (click)="onClose()">
    Close
  </button>
  <button type="button" class="btn btn-primary"
          [disabled]="!cpuDetails.valid || !diskDetails.valid || !cloudInfraDetails.valid || !socketsAndCoreDetails.valid || !gpuDetails.valid || !rdmaDetails.valid"
          (click)="onSubmit(cpuDetails,diskDetails,cloudInfraDetails,socketsAndCoreDetails,gpuDetails,rdmaDetails)">
    Submit
  </button>
</div>
